var p={HelpTip:"HelpTip__HelpTip-mzY"};export{p as default};
